import React, { useState, useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";

export const AthleteWarmupRoutinePhase = () => {
  const { athlete } = useAthleteAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [phases, setPhases] = useState([]); // State for storing fetched phases
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [selectedDate, setSelectedDate] = useState(new Date()); // State for selected date
  
  // Fetch phases from the server
  const fetchPhasesData = async (date) => {
    setIsLoading(true);
    setError(null);

    try {
      const formattedDate = formatForAPI(date); // Format date as YYYY-MM-DD
      const response = await fetch(`${API_URL.GET_ATHLETE_WARMUP_ROUTINE_PHASES}${athlete.email}/${formattedDate}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${athlete.token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData?.error || "Failed to fetch phases data");
        return;
      }

      const data = await response.json();
      setPhases(data); // Update current phases
    } catch (err) {
      setError(err.message || "Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

 // Handle component initialization and data fetching
 useEffect(() => {
  // Check if data exists in location.state
  if (location.state?.phases && location.state?.selectedDateState) {
    console.log("Using data from location.state");
    console.log(location.state);
    setPhases(location.state.phases);
    setSelectedDate(location.state.selectedDateState);
  } 
    //case of only selecteddate found in state, other coukd be phases etc
 else if(location.state?.selectedDateState)
 {
        console.log("Using only date from location.state");
        console.log(location.state);
        setSelectedDate(location.state.selectedDateState);
        fetchPhasesData(location.state.selectedDateState);
  }
  else {
    console.log("Fetching data for selected date");
    fetchPhasesData(selectedDate);
  }
}, [location.state, athlete.email, athlete.token, selectedDate]);

  // Format date as "YYYY-MM-DD"
  const formatForAPI = (date) => {
    const utcDate = new Date(date);  // Ensure UTC consistency
    utcDate.setUTCHours(0, 0, 0, 0); // Clear time component for accurate matching
    return utcDate.toISOString().split('T')[0];
  };
  
  // Function to update the date correctly
  const changeDate = (days) => {
    location.state=null; //clear state on date change as then it is new load
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };
  
  // Format date for display
  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const handleAmaxSpeedWorkoutClick = () => {
    navigate("/athlete/amax-speed-workout/",{ state: { phases,selectedDate } });
  };


  return (
    <AthleteLayout>
      <div className="bg-white">
        <AthleteHeader />
      </div>
      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">{formatDate(selectedDate)}</p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="w-full max-w-2xl mx-auto h-full bg-black">
        <div className="text-white py-3 bg-black">
          <div className="flex justify-between gap-[68px] mb-4 px-5">
            <button className="text-white border-b-2 border-white text-base pb-2 font-normal">
              Warmup 
            </button>
            <button onClick={handleAmaxSpeedWorkoutClick} className="text-lightSmock text-base pb-2 font-normal">
               Workout
            </button>
          </div>

          {isLoading ? (
            <p className="text-white text-center">Loading phases...</p>
          ) : error ? (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">{error}</div>
          ) : (
            <div className="space-y-[15px] overflow-hidden overflow-y-auto px-5">
              {phases &&
                phases.map((item) => (
                  <button
                    onClick={() => navigate('/athlete/warmup-routine/phase-exercise/' + item.phase_id + "/" + item._id, { state: { phases,selectedDate } })}
                    key={item.phase_id}
                    className="w-full p-[14px] text-white font-normal border border-white/20 bg-transparent rounded-[15px] hover:bg-white/10 transition text-start"
                  >
                    {item.title} {/* Display label here */}
                  </button>
                ))}
            </div>
          )}
        </div>
      </div>
    </AthleteLayout>
  );
};

const ArrowG = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowL = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
